import { z } from 'zod';

/**
 * サーバーの VM の中の Web（ボイスチャットの Web 画面など）を、edge の Caddy で
 * https://<label>.<ドメイン> として公開する設定。
 */
export const WEB_SITE_RESERVED_LABELS = ['panel', 'mcp', 'play', 'www', 'edge', 'admin', 'api'] as const;
/** Minecraft・RCON は Web として出さない */
export const WEB_SITE_BLOCKED_PORTS = [25565, 25575] as const;

export const WebSiteLabelSchema = z
  .string()
  .regex(
    /^[a-z0-9](?:[a-z0-9-]{0,30}[a-z0-9])?$/,
    '英小文字・数字・ハイフンの 1〜32 文字で、先頭と末尾は英数字にしてください',
  )
  .refine((label) => !(WEB_SITE_RESERVED_LABELS as readonly string[]).includes(label), 'この名前は使えません');
export const WebSitePortSchema = z
  .number()
  .int()
  .min(1024, '1024〜65535 の番号にしてください')
  .max(65535, '1024〜65535 の番号にしてください')
  .refine(
    (port) => !(WEB_SITE_BLOCKED_PORTS as readonly number[]).includes(port),
    'Minecraft・RCON のポートは公開できません',
  );
export const WebSiteSchema = z.object({ label: WebSiteLabelSchema, port: WebSitePortSchema }).strict();
export const WebSitesInputSchema = z
  .object({ sites: z.array(WebSiteSchema).max(10) })
  .strict()
  .refine((input) => new Set(input.sites.map((s) => s.label)).size === input.sites.length, '同じ名前が重複しています');
export type WebSite = z.infer<typeof WebSiteSchema>;
export interface WebSitesView {
  domain: string;
  sites: Array<WebSite & { url: string }>;
}
